class FantasticCountdown extends HTMLElement {
  constructor() {
    super();

    this.container = this.querySelector("#container-section");
    this.finalMessage = this.querySelector("#ff-final-message");
    this.containerId = this.querySelector("#ff-container-id-format-clock");
    this.messageEnds = this.querySelector(".ff-end-in");

    this.days = this.querySelector("#days");
    this.hours = this.querySelector("#hours");
    this.minutes = this.querySelector("#minutes");
    this.seconds = this.querySelector("#seconds");

    this.params = JSON.parse(this.dataset.params)[0];
    this.timer;
    this.msCountdown(this.params);
  }

  msCountdown({ year, month, day, hour, min, sec }) {
    const compareDate = new Date(year, month - 1, day, hour, min, sec);
    compareDate.setDate(compareDate.getDate()); //just for this demo today + 7 days
    this.timeBetweenDates(compareDate);

    this.timer = setInterval(() => {
      this.timeBetweenDates(compareDate);
    }, 1000);
  }

  timeBetweenDates(toDate) {
    const dateEntered = toDate;
    const now = new Date();
    const difference = dateEntered.getTime() - now.getTime();
    if (difference <= 0) {
      this.finalMessage.classList.remove("ff-hide-element");
      this.containerId.classList.add("ff-hide-element");
      this.messageEnds.classList.add("ff-hide-element");
      this.container.style.paddingTop = "10px";
      this.container.style.paddingBottom = "10px";
      // Timer done
      clearInterval(this.timer);
    } else {
      this.container.classList.contains("ff-hide-element") &&
        this.container.classList.remove("ff-hide-element");
      let seconds = Math.floor(difference / 1000);
      let minutes = Math.floor(seconds / 60);
      let hours = Math.floor(minutes / 60);
      let days = Math.floor(hours / 24);

      hours %= 24;
      minutes %= 60;
      seconds %= 60;
      days < 10
        ? (this.days.innerHTML = "0" + days + " " +"days")
        : (this.days.innerHTML = days + " " + "days");

      hours < 10
        ? (this.hours.innerHTML = "0" + hours + " " + "hours")
        : (this.hours.innerHTML = hours + " " + "hours");

      minutes < 10
        ? (this.minutes.innerHTML = "0" + minutes + " " + "minutes")
        : (this.minutes.innerHTML = minutes + " " + "minutes");

      seconds < 10
        ? (this.seconds.innerHTML = "0" + seconds + " " + "seconds")
        : (this.seconds.innerHTML = seconds + " " + "seconds");
    }
  }
}

customElements.define("ff-countdown", FantasticCountdown);
